import styled from 'styled-components/native'

import Body from '@hedgit/lib/components/typography/body'

export const Container = styled.View`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  padding: 16px;
  margin-top: 6px;
  border-radius: 10px;
  border: 1px dashed #979c9f;
  height: 95px;
  background-color: ${props => props.theme.colors.whiteDark};
  max-width: 400px;
`

export const Icon = styled.View`
  display: flex;
  justify-content: center;
  align-self: flex-start;
  align-items: center;
  border-radius: 50%;
  height: 30px;
  width: 30px;
  background-color: #e6e8ea;
`

export const Content = styled.View`
  width: 267px;
`

export const CardText = styled(Body)`
`

export const CardText2 = styled(Body)`
  width: 260px;
`
